import React from "react";
import {
  Table,
  TableBody,
  Paper,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import UseStyles from "./UseStyles";
import Utils from "../../Utils";

const Deal = ({ dealData }) => {
  const classes = UseStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.header_bold} align="left"></TableCell>
            <TableCell className={classes.header_bold} align="left">Deal No.</TableCell>
            <TableCell className={classes.header_bold} align="center">
              Structure
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
              Buy Rate
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
              Term
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
              Financed Amount
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
              Down Payment
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
               Payment
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
              NMEF Doc Fees
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
              Total Due to Vendor
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
              Advance Payments
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
              Advance Payment Total
            </TableCell>
            <TableCell className={classes.header_bold} align="center">
              Total Due at Signing
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dealData.map((row, i) => (
            <TableRow
              className={
                row.selected_for_submitted_deal
                  ? classes.deal_grid_selected
                  : null
              }
              key={i}
            >
              {row.selected_for_submitted_deal ? (
                <TableCell
                  className={
                    row.selected_for_submitted_deal
                      ? classes.text_color_set
                      : null
                  }
                  align="center"
                >
                  S
                </TableCell>
              ) : row.selected_for_proposal ? (
                <TableCell align="center">P</TableCell>
              ):  <TableCell align="center"></TableCell>}
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
              >
                {/* 00{i + 1} */}
                {row.name} {row.is_lmd && <span>&nbsp;(LMD)</span>}
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
              >
                {row.final_deal_structure}
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
              >
                {row.final_buy_rate}
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
              >
                {row.final_term}
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
                align="center"
              >
                {"$" + Utils.formatCurrencyNumber(row.final_customer_financed_amount)}
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
                align="center"
              >
                {"$" + Utils.formatCurrencyNumber(row.final_cap_cost_reduction)}
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
                align="center"
              >
                {"$" + Utils.formatCurrencyNumber(row.final_monthly_payment)}
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
                align="center"
              >
                {"$" + Utils.formatCurrencyNumber(row.final_doc_fee)}
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
                align="center"
              >
                {"$" + Utils.formatCurrencyNumber(row.final_customer_financed_amount)}
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
                align="center"
              >              
               {(row.last_payment_required)  ? 2 : ((row.first_payment_required && !row.last_payment_required) ?  1 : 0)}
                             
              </TableCell>
              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
                align="center"
              >
                {"$" +
                  Utils.formatCurrencyNumber(row.required_advance_payment)}
              </TableCell>

              <TableCell
                className={
                  row.selected_for_submitted_deal
                    ? classes.text_color_set
                    : null
                }
                align="center"
              >
                {"$" +  Utils.formatCurrencyNumber(row.final_total_customer_due_at_signing) }
              </TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default Deal;
